export const PROCEED_EVENT_NAME = 'proceed'
export const FLOW_RESIDENCE_WIDGET_QC_TEST_ID = 'flow-residence-widget-qc'
export const RESIDENCE_CARD_WARNING_TEST_ID = 'residence-card-warning'
export const RESIDENCE_INPUT_TEST_ID = 'residence-input'
export const VISITORS_LINK_TEST_ID = 'visitors-link'
export const RESIDENCE_PRIORITY_IDS = [
  '008',
  '004',
  '006',
  '005',
  '077',
  '059',
  '002',
  '012',
  '081',
  '192',
  '062',
  '082',
  '039',
  '032',
  '070',
  '033',
  '023',
  '011',
]
